import React from 'react';
import {
    RawPurchaseEntryBase,
    buildRawPurchaseEntryDetailPanelTypes,
    buildRawPurchaseEntryHiddenPanelTypes,
    buildRawPurchaseEntryTotalPanelDefinitions,
    RAW_PURCHASE_ENTRY_FIELD_IDS,
    buildRawPurchaseEntryReferenceHooks
} from './RawPurchaseEntryBase';

const HEADER_LOCK_COLUMN_IDS = [
    "ZSR_ZAIRYOKBN",
    "ZSR_SIIREKIND",
    "ZSR_DENSYUBETU",
    "ZSR_SIIREKBN",
    "ZSR_SHIREBI",
    "ZSR_SENPODENNO",
    "ZSR_BRDCD",
    "ZSR_SIIRESAKIKBN",
    "ZSR_SIIRESAKICD",
    "ZSR_SIIRESAKISUBCD",
    "TOR_BUMONNM",
    "TOR_TANTONM",
    "ZSR_KAIGAIKBN",
    "ZSR_TEKIYO"
];

const detailPanelTypesByMaterialCategory = buildRawPurchaseEntryDetailPanelTypes("910", "920", "930");
const entryHooks = buildRawPurchaseEntryReferenceHooks(
    HEADER_LOCK_COLUMN_IDS,
    "参照元の明細は編集できません"
);

const entryConfig = {
    screenId: "RawPurchaseEntryRawSmplDel",
    apiController: "RawPurchase",
    dataController: "RawPurchase",
    layoutController: "RawPurchase",
    formKey: "RawPurchaseEntryRawSmplDel",
    listController: "RawSmplDel",
    callerIdentifier: "RawSmplDel",
    sourceCategoryCode: "9",
    primarykeys: ["ZSR_DENNO"],
    sourceCategoryColumnId: RAW_PURCHASE_ENTRY_FIELD_IDS.sourceCategoryCode,
    materialCategoryColumnId: "ZSR_ZAIRYOKBN",
    materialCategoryStateKeys: [
        "materialCategoryCode"
    ],
    detailPanelTypesByMaterialCategory: detailPanelTypesByMaterialCategory,
    hiddenPanelTypesByMaterialCategory: buildRawPurchaseEntryHiddenPanelTypes("910", "920", "930"),
    totalPanelDefinitions: buildRawPurchaseEntryTotalPanelDefinitions("911", "921", "931"),
    entryHooks: entryHooks
};

export const RawPurchaseEntryRawSmplDel = React.forwardRef((props, ref) => {
    return <RawPurchaseEntryBase {...props} ref={ref} entryConfig={entryConfig} />;
});
